import LayerList from "@arcgis/core/widgets/LayerList";
import LayerListItemPanelWidget from "../../custom/layer-list-item-panel/LayerListItemPanelWidget";
import ReactDOM from "react-dom";
import React from "react";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import {
  observerAddToHandles,
} from "../../../handles/Handles";

const MapLayersVM = async (view, container, mapId) => {
  const mapLayers = await view.when(() => {
    addLocalStorageListLayers(mapId, view);

    const widget = new LayerList({
      view: view,
      container: container,
      selectionEnabled: true,
      listItemCreatedFunction: (e) => defineActions(view, e, mapId),
    });
    return widget;
  });
  return mapLayers;
};

export default MapLayersVM;

const defineActions = (view, event: any, mapId) => {
  const { item } = event;

  let showLabelToggle = true;

  if (item.layer.type === "imagery") {
    item.layer.listMode = "hide";
  }
  if (item.layer.type === "map-image") {
    item.layer.listMode = "hide-children";
    //this updates the label layer to have the same value as the feature layer in visibility and opacity
    if (item.layer.customParameters?.isLabelLayer) {
      item.layer.listMode = "hide";
     }
  }
  observerAddToHandles(
    reactiveUtils.when(
      () => item.visible,
      (visible) => {
        if (visible) {
          if (item.parent) {
            item.parent.visible = visible;
          }
        }
      }
    ),
    `${item.layer.title}-${item.layer.id}-parent-visible-handle`
  );

  // if(item.layer.type === "group"){
  //   item.layer.visibilityMode = "inherited";
  // }

  //this sets the observer to change the labels layer with the corresponding feature layer
  if (item.layer.type === "feature") {
    let layerArray = view.map.allLayers.filter((layer) => {
      return layer.title === `${item.layer.title} Labels`;
    });
    
    if (layerArray.length > 0) {
      let layerLabel = layerArray.getItemAt(0);
      item.sortable = false;
      showLabelToggle = false;
      observerAddToHandles(
        reactiveUtils.watch(
          () => [item.layer.visible, item.layer.opacity],
          ([visible, opacity]) => {
            layerLabel.visible = visible;
            layerLabel.opacity = opacity;
          }
        ),
        `${item.layer.title}-${item.layer.id}-image-label-handle`
      );
    }
  }

  if (item.layer.type === "feature" || item.layer.type === "map-image") {
    const { layer } = item;
    layer.when(() => {
      const node = document.createElement("div");
      ReactDOM.render(
        <React.StrictMode>
          <div>
            <LayerListItemPanelWidget
              layer={item.layer}
              view={view}
              showLabelToggle={showLabelToggle}
            />
          </div>
        </React.StrictMode>,
        node
      ) as unknown as HTMLElement;
      item.panel = {
        content: [/*"legend", layerListItemPanel,*/ node],
        className: "esri-icon-layer-list",
        open: false,
        title: "options",
      };
    });
  }
};

export const saveListLayerConfig = (view, mapId) => {
  let obj = {};
  view.map.allLayers.forEach((layer) => {
    obj[layer.title] = { visible: layer.visible, opacity: layer.opacity }
    if(layer.hasOwnProperty("labelsVisible")){
      obj[layer.title].labelsVisible=layer.labelsVisible
    }
      if(layer.parent.hasOwnProperty("layers")&& layer.type!=='elevation' && layer.type !=='tile' && layer.type !=='imagery'){
        obj[layer.title].index=layer.parent.layers.indexOf(layer)
      }
      let sessionLayerObject=JSON.parse(sessionStorage.getItem(`${layer.title}-useCustomLabel`))
      if(sessionLayerObject?.label){
        obj[layer.title].labelInfo=JSON.stringify(sessionLayerObject)
      }
  });
  localStorage.setItem(`listLayers-${mapId}`, JSON.stringify(obj));
  // let baseLayer=view.map.basemap.baseLayers.getItemAt(0)
  // if(baseLayer.hasOwnProperty("opacity")){
  //   localStorage.setItem(`baseLayersOpacity-${mapId}`, JSON.stringify(Math.round(baseLayer.opacity*100)));
  // };
};

export const clearListLayerConfig = (mapId) => {
  localStorage.removeItem(`listLayers-${mapId}`);
  localStorage.removeItem(`baseLayersOpacity-${mapId}`);
};

export const addLocalStorageListLayers = (mapId, view) => {
  if (localStorage.hasOwnProperty(`listLayers-${mapId}`)) {
    let listLayerObject = JSON.parse(
      localStorage.getItem(`listLayers-${mapId}`)
    );
     // view.map.when(_=>{
    view.map.allLayers.forEach(layer=>{
    if (listLayerObject.hasOwnProperty(layer.title)) {
      layer.visible = listLayerObject[layer.title].visible;
      layer.opacity = listLayerObject[layer.title].opacity;
      if(listLayerObject[layer.title].hasOwnProperty('labelsVisible')){
        layer.labelsVisible=listLayerObject[layer.title].labelsVisible
      }

      if(listLayerObject[layer.title].hasOwnProperty('index')){
        layer.parent.when((parent)=>{
          parent.layers.reorder(layer, listLayerObject[layer.title].index);
        })
        
      }
    }
  })
//})
  }
};
